import React, { useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import AppContext from "../../../utils/context";
import Markdown from "react-markdown";

export default function View(props) {
  const appContext = useContext(AppContext);
  // Replace literal '\n' with actual line breaks
  const content = props?.format_data?.content?.replace(/\\n/g, "\n");
  return (
    content && <Markdown className="no-drag">{content}</Markdown>
  );
}
